import type { ReactNode } from 'react';

import { routes } from '@/constants/Constants';
import { UserPermissions } from '@/constants/permissions.constant';
import { usePermission } from '@/hooks/usePermission';
import { Navigate } from 'react-router';

type SSUMFeatureGuardProps = {
  children: ReactNode;
  redirectUrl?: string;
};

/**
 * A guard component that protects SSUM routes by checking that the user has the
 * CanManageUsers permission. Redirects to the specified URL if the check fails.
 */
export function SSUMFeatureGuard(props: SSUMFeatureGuardProps) {
  const { children, redirectUrl } = props;

  const { enabled: canManageUsersEnabled } = usePermission(UserPermissions.User.CanManageUsers);

  const usedRedirectUrl = redirectUrl ?? routes.home;

  if (!canManageUsersEnabled) {
    return <Navigate to={usedRedirectUrl} replace />;
  }

  return <>{children}</>;
}
